module.exports = __webpack_public_path__ + "static/media/1280px-React-icon.svg.638be909.png";